import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Input from "../../common/Input";
import Dropdown from "../Dropdown";
import {getOtherCorrelatedEntitiesTypes} from "../../../_data/mydata/otherCorrelatedEntities";
import {getCountryOptions, isEmpty, validateAFM} from "../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import AdvancedCombobox from "../AdvancedCombobox";
import axios from "axios";
import {useSelector} from "react-redux";
import NewClientModal from "../../layouts/data-panel/Clients/new-client-modal";
import {useTranslation} from "../../../hooks/useTranslation";

const OtherCorrelatedEntitiesModal = ({entity, setSelectedEntity, otherCorrelatedEntities, setOtherCorrelatedEntities}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const {t} = useTranslation();
    const [entityData, setEntityData] = useState(entity);
    const [show, setShow] = useState(false);

    const [entitiesList, setEntitiesList] = useState([]);

    useEffect(() => {
        if (entity) {
            setEntityData(entity);
            setShow(true);
        }
    }, [entity]);

    useEffect(() => {
        if (show) {
            loadEntitiesList(null, setEntitiesList);
        }
    }, [show])

    const closeModal = () => {
        setSelectedEntity(null);
        setShow(false);
    }

    const deleteEntity = () => {
        let cloneEntities = [...otherCorrelatedEntities];
        const findIndex = cloneEntities.findIndex((entity) => entity.id === entityData?.id);
        if (findIndex !== -1) {
            cloneEntities.splice(findIndex, 1);
            cloneEntities = cloneEntities.map((item, index) => ({...item, id: index + 1}));
            toast.success("Επιτυχής Διαγραφή Οντότητας!");
            setOtherCorrelatedEntities(cloneEntities);
            closeModal();
        }
    }

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "dropdown") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acdd") {
            if (name === "client") {
                const obj = e.row;
                prepChange["name"] = obj.name;
                prepChange["vatNumber"] = obj.vatNumber;
                prepChange["country"] = obj.country || "GR";
                prepChange["address"] = obj.address || "";
                prepChange["city"] = obj.city || "";
                prepChange["postalCode"] = obj.postalCode || "";
            }
        }
        setEntityData({...entityData, ...prepChange});
    }

    const saveClicked = () => {
        if (!entityData?.type || entityData.type === "new" || !entityData?.country || !entityData?.name || !entityData?.vatNumber) {
            toast.error("Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία!");
        } else if (entityData?.country === "GR" && validateAFM(entityData.vatNumber) === false) {
            toast.error("Το Α.Φ.Μ. που συμπληρώσατε δεν είναι σωστό.");
        } else if ((entityData?.address || entityData?.city || entityData?.postalCode) && (!entityData?.address || !entityData?.city || !entityData?.postalCode)) {
            toast.error("Παρακαλώ συμπληρώστε όλα τα πεδία της διεύθυνσης!");
        } else {
            const cloneEntities = [...otherCorrelatedEntities];
            const findIndex = cloneEntities.findIndex((entity) => entity.id === entityData?.id);
            if (findIndex !== -1) {
                cloneEntities[findIndex] = entityData;
                toast.success("Επιτυχής Ενημέρωση Οντότητας!");
            } else {
                cloneEntities.push(entityData);
                toast.success("Επιτυχής Προσθήκη Οντότητας!");
            }
            setOtherCorrelatedEntities(cloneEntities);
            closeModal();
        }
    }

    const loadEntitiesList = (name, setData) => {
        const reqData = {
            company: company.id,
        }
        if (!isEmpty(name)) reqData.name = name;

        axios.post(`${process.env.REACT_APP_API_URL2}/sale/list-available-carriers`, reqData, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    let filteredData = res.data.data;
                    if (setData) setData(filteredData);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    return (
        <Modal backdrop={"static"} show={show} onHide={() => closeModal()} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Συσχετιζόμενη Οντότητα</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {entityData !== null && (
                    <React.Fragment>
                        <Dropdown
                            name={"type"}
                            label={"Τύπος Οντότητας"}
                            options={getOtherCorrelatedEntitiesTypes}
                            required={true}
                            key={Math.random()}
                            defaultValue={getOtherCorrelatedEntitiesTypes.find((el) => String(el.value) === String(entityData?.type))}
                            onChange={(e) => handleOnChange(e, "dropdown", "type")}
                        />
                        <Row className={"mb-3"}>
                            <Col md={10}>
                                <AdvancedCombobox
                                    ACName="Sales Client" // do not change name
                                    className="w-200 ac-select-dropdown"
                                    key={entityData?.name || ""}
                                    defaultValue={entityData?.name || ""}
                                    label={"Οντότητα"}
                                    data={entitiesList}
                                    onChangeSearch={(keyword, setData) => loadEntitiesList(keyword, setData)}
                                    onChange={(e) => handleOnChange(e, 'acdd', 'client')}
                                    excludeColumns={[]}
                                    columns={
                                        [{
                                            label: t("General.name"),
                                            name: "name",
                                        },
                                        {
                                            label: t("General.vatNumber"),
                                            name: "vatNumber",
                                        },
                                        {
                                            label: t("General.phone"),
                                            name: "phone",
                                        },
                                        {
                                            label: t("General.email"),
                                            name: "email",
                                        }]
                                    }
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={"Επιλέξτε οντότητα"}
                                    required={true}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                    disabled={String(entityData.name).length > 0}
                                />
                            </Col>
                            <Col md={2}>
                                {entityData.name ? (
                                    <button style={{marginTop: "28px"}} className="btn quick-retail-clientbtn btn-default btn-sm" title="Αποεπιλογή οντότητας" onClick={() => {
                                        setEntityData({
                                            ...entityData,
                                            country: "GR",
                                            name: "",
                                            address: "",
                                            city: "",
                                            postalCode: "",
                                            vatNumber: ""
                                        })
                                    }}><i className="fas fa-xmark"></i></button>
                                ) : (
                                    <div title={"Καταχώρηση οντότητας"} style={{paddingTop: "23px"}}>
                                        <NewClientModal successCallback={(data) => handleOnChange({row: data}, "acdd", "client")} />
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Dropdown
                                    name={"country"}
                                    label={"Χώρα"}
                                    options={getCountryOptions('all')}
                                    required={true}
                                    key={Math.random()}
                                    disabled={true}
                                    defaultValue={getCountryOptions('all').find((el) => String(el.value) === String(entityData?.country))}
                                    onChange={(e) => handleOnChange(e, "dropdown", "country")}
                                />
                            </Col>
                            <Col md={6}>
                                <Input
                                    name={"vatNumber"}
                                    label={"Α.Φ.Μ."}
                                    required={true}
                                    value={entityData?.vatNumber}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                        <Input
                            name={"address"}
                            label={"Διεύθυνση"}
                            className={"mb-2"}
                            value={entityData?.address}
                            onChange={(e) => handleOnChange(e, "input", "address")}
                        />
                        <Row>
                            <Col md={6}>
                                <Input
                                    name={"city"}
                                    label={"Πόλη"}
                                    className={"mb-2"}
                                    value={entityData?.city}
                                    onChange={(e) => handleOnChange(e, "input", "city")}
                                />
                            </Col>
                            <Col md={6}>
                                <Input
                                    name={"postalCode"}
                                    label={"Ταχυδρομικός Κώδικας"}
                                    className={"mb-2"}
                                    value={entityData?.postalCode}
                                    onChange={(e) => handleOnChange(e, "input", "postalCode")}
                                />
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                {entity?.type !== "new" ? (
                    <Button variant="outline-primary" onClick={() => deleteEntity()}>Διαγραφή</Button>
                ) : (
                    <Button variant="outline-primary" onClick={() => closeModal()}>Κλείσιμο</Button>
                )}
                <Button variant="primary" onClick={() => saveClicked()}>Αποθήκευση</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default OtherCorrelatedEntitiesModal;
